import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["value", "checked"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("label", {
    class: "upsells-category-tag configurator-upsells_filter",
    onChange: _cache[0] || (_cache[0] = _withModifiers($event => (_ctx.$emit('selected')), ["prevent"]))
  }, [
    _createElementVNode("span", null, _toDisplayString($props.label), 1 /* TEXT */),
    _createElementVNode("input", {
      type: "radio",
      name: "card-category-tag",
      value: $props.label,
      checked: $props.isActive
    }, null, 8 /* PROPS */, _hoisted_1)
  ], 32 /* NEED_HYDRATION */))
}